import { fb, validators } from '../../../lib/form';

export function GetResetPasswordModel(data){
  const model = fb.group({
    password: [data.password || '', [validators.Required()], { label: 'Current Password', type: 'password' }],
    newPassword: [data.newPassword || '', [validators.Required(), validators.Length('Min 7 characters', {min: 7})], { label: 'New Password', type: 'password' }],
  }); 
  return model;
}